import React, { Component } from "react";

import PageLayout from '../../components/layout/PageLayout'
import {ThemeProps} from "../../components/styles/themeprops";
import Greeting from "../../components/greeting/Greeting";
import Mission from "../../components/greeting/Mission";
import Branchen from "../../components/greeting/Branchen";
import OurServices from "../../components/ourservices/OurServices";

type Props = {
  theme: ThemeProps,
}
class Home extends Component<Props> {
  render() {
    return (
      <PageLayout title="Home" theme={this.props.theme}>
      	<Greeting theme={this.props.theme} />
				<Mission theme={this.props.theme} />
				{/*<Branchen theme={this.props.theme} />*/}
				
				<OurServices theme={this.props.theme}/>
				
      </PageLayout>
    );
  }
}

export default Home;
